import { h } from "../lib/ui";

const P = {
  overview: "M3.5 3.5h7v7h-7zM13.5 3.5h7v4.5h-7zM13.5 11h7v9.5h-7zM3.5 13.5h7v7h-7z",
  home: "M4 10.5 12 4l8 6.5V20h-5.5v-5.5h-5V20H4z",
  tool: "M14.6 3.6a4.6 4.6 0 0 0-5.3 6.1L3.6 15.4a1.9 1.9 0 0 0 2.7 2.7l5.7-5.7a4.6 4.6 0 0 0 6.1-5.3l-2.6 2.6-2.5-.4-.4-2.5z",
  calendar: "M4 5.5h16v15H4zM4 10h16M8.5 3v4M15.5 3v4",
  users: "M9 11.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM2.5 20c.8-3.6 3.4-5.6 6.5-5.6s5.7 2 6.5 5.6M16.5 4.8a3 3 0 0 1 0 5.8M18 14.6c2 .5 3.3 2.2 3.8 5.1",
  palette: "M12 3a9 9 0 1 0 0 18c1.2 0 1.8-1 1.3-2l-.4-.8c-.6-1.2.3-2.6 1.6-2.6H17a4 4 0 0 0 4-4c0-4.8-4-8.6-9-8.6z",
  sliders: "M4 6.5h9M17 6.5h3M4 12h3M11 12h9M4 17.5h11M19 17.5h1M15 4.5v4M9 10v4M17 15.5v4",
  shield: "M12 3.2 19.5 6v5.8c0 4.4-3.2 8-7.5 9-4.3-1-7.5-4.6-7.5-9V6zM9 12l2.2 2.2L15.2 10",
  badge: "M4 5.5h16v13H4zM9 12.2a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2zM5.9 16c.6-1.5 1.7-2.2 3.1-2.2s2.5.7 3.1 2.2M14.5 9.5h3.5M14.5 13h2.5",
  log: "M9 6.5h11M9 12h11M9 17.5h11M4.5 6.5h.01M4.5 12h.01M4.5 17.5h.01",
  briefcase: "M3.5 7.5h17v12h-17zM9 7.5V5.2c0-.4.3-.7.7-.7h4.6c.4 0 .7.3.7.7v2.3M3.5 12.5h17",
  checklist: "M5 3.5h14v17H5zM8.2 8.6l1.3 1.3 2.3-2.4M8.2 14.6l1.3 1.3 2.3-2.4M14 9h2.5M14 15h2.5",
  logout: "M14.5 4H18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3.5M10 16l-4-4 4-4M6 12h10",
  back: "M15 18l-6-6 6-6",
  next: "M9 6l6 6-6 6",
  plus: "M12 5v14M5 12h14",
  check: "M5 12.5l4.5 4.5L19 7",
  x: "M6.5 6.5l11 11M17.5 6.5l-11 11",
  alert: "M12 4.2 21 19.5H3zM12 10v4.2M12 17h.01",
  camera: "M4 8h3.2l1.8-2.7h6l1.8 2.7H20v11.5H4zM12 16.5a3.3 3.3 0 1 0 0-6.6 3.3 3.3 0 0 0 0 6.6z",
  video: "M3.5 6.5h12v11h-12zM15.5 10.5l5-3v9l-5-3",
  lock: "M5.5 11h13v9.5h-13zM8.5 11V8a3.5 3.5 0 0 1 7 0v3",
  power: "M12 3.5v8M6.6 6.9a7.5 7.5 0 1 0 10.8 0",
  phone: "M5.5 4h3.3l1.7 4.4-2.1 1.3a11 11 0 0 0 5.9 5.9l1.3-2.1 4.4 1.7v3.3a1.8 1.8 0 0 1-1.9 1.8C10.6 19.8 4.2 13.4 3.7 5.9A1.8 1.8 0 0 1 5.5 4z",
  menu: "M4 7h16M4 12h16M4 17h16",
  pin: "M12 21s-6.5-5.8-6.5-11a6.5 6.5 0 0 1 13 0c0 5.2-6.5 11-6.5 11zM12 12a2.3 2.3 0 1 0 0-4.6 2.3 2.3 0 0 0 0 4.6z",
  door: "M6.5 3.5h11v17h-11zM14.5 12h.01M3.5 20.5h17",
  clock: "M12 20.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17zM12 7.5V12l3 2",
  upload: "M12 15.5V4.5M7.5 9 12 4.5 16.5 9M5 19.5h14",
  eye: "M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
  eyeOff: "M3.5 3.5l17 17M10.6 5.6c.5-.1.9-.1 1.4-.1 6 0 9.5 6.5 9.5 6.5a17 17 0 0 1-2.7 3.5M6.3 6.9C3.9 8.6 2.5 12 2.5 12S6 18.5 12 18.5c1.7 0 3.2-.5 4.4-1.2M9.9 9.9a3 3 0 0 0 4.2 4.2",
  mail: "M3.5 5.5h17v13h-17zM3.8 6l8.2 6.5L20.2 6",
  key: "M8 14.5a4.5 4.5 0 1 1 3.9-6.8L20.5 7.7v3.3h-2.5v2.5h-3l-1.3-1.3a4.5 4.5 0 0 1-5.7 2.3zM7 11.2h.01",
  search: "M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14zM20 20l-4-4",
  download: "M12 4.5v11M7.5 11l4.5 4.5 4.5-4.5M5 19.5h14",
  link: "M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1",
  copy: "M8.5 8.5h11v11h-11zM15.5 8.5v-4h-11v11h4",
  user: "M12 11.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4.5 20.5c.9-4 3.8-6.2 7.5-6.2s6.6 2.2 7.5 6.2",
  route: "M6 19.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM18 9.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM8.5 17h6a3 3 0 0 0 0-6h-5a3 3 0 0 1 0-6h6",
};

export type IconName = keyof typeof P;

export function Icon(props: { name: IconName; size?: number; class?: string; label?: string }) {
  const s = props.size ?? 20;
  return (
    <svg
      width={s}
      height={s}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
      class={props.class}
      aria-hidden={props.label ? undefined : "true"}
      role={props.label ? "img" : undefined}
      aria-label={props.label}
    >
      <path d={P[props.name]} />
    </svg>
  );
}

/** The brand's roofline: a large chevron with the hearth dot, drawn in the accent colour. */
export function Roofline(props: { class?: string }) {
  return (
    <svg class={props.class} viewBox="0 0 330 210" fill="none" aria-hidden="true">
      <path d="M38 118 165 22l127 96" stroke="var(--c-accent)" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" opacity="0.35" />
      <path d="M18 160 165 49l147 111" stroke="var(--c-accent)" stroke-width="14" stroke-linecap="round" stroke-linejoin="round" />
      <circle cx="165" cy="146" r="15" fill="var(--c-accent)" />
    </svg>
  );
}
